import { AbTestData } from '@/scopes/common/infrastructure/ab-testing/edge-function/types'
import * as React from 'react'

export const AbTestContext = React.createContext<AbTestData>({
  isEnabled: false,
  isBVariant: false,
})

export const AbTestProvider = AbTestContext.Provider

export const useAbTestContext = () => React.useContext(AbTestContext)
